<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <div class="group">
                <div class="page-group-title"><span>基本信息</span></div>
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="name" label="代理商名称:">
                            <el-input v-model="formData.name" :maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="principalId" label="代理商负责人:">
                            <el-select v-model="formData.principalId" filterable remote :remote-method="searchPrincipal"
                                :loading="userLoading" size="medium">
                                <el-option v-for="item in principalList" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>合同信息</span></div>
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="contractSn" label="合同编号:">
                            <el-input v-model="formData.contractSn" :maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="contractExpireTime" label="合同到期时间:">
                            <el-date-picker v-model="formData.contractExpireTime" type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>代理费</span>作为默认值, 关联的每场演出上可以修改</div>
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="serviceFeeType" label="收取方式:">
                            <el-select v-model="formData.serviceFeeType" @change="scopeChange">
                                <el-option :value="0" label="不收取"></el-option>
                                <!-- <el-option :value="1" label="固定金额"></el-option> -->
                                <el-option :value="2" label="按比例收取"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="formData.serviceFeeType == 2" :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="serviceFee" label="代理费占票提比例:" :rules="[{ required: true, message: '请输入代理费占票提比例' }]">
                            <el-row :gutter="10">
                                <el-col :span="22">
                                    <el-input-number style="width:100%" v-model="formData.serviceFee"
                                        controls-position="right" :step="0.01" :min="0.01" :max="100.00"
                                        :precision="2"></el-input-number>
                                </el-col>
                                <el-col :span="2">
                                    %
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>收款信息</span></div>
                <ReceiptInfo :formData.sync="formData" :accountTypeDisable="true"></ReceiptInfo>
            </div>
            <div class="group MT20">
                <div class="page-group-title"><span>证件信息</span></div>
                <AccountInfo :formData.sync="formData"></AccountInfo>
            </div>
        </el-form>
        <div class="group MT20">
            <el-button @click="goBack">返回</el-button>
            <el-button v-if="$utils.have('/agent/edit')" type="primary" @click="onSubmit"
                :loading="btnLoading">提交</el-button>
        </div>
    </div>
</template>

<script>
import ReceiptInfo from '@/views/finance/components/receiptInfo';
import AccountInfo from '@/views/finance//components/accountInfo';
const defaultFormData = {
    name: "",
    principalId: "",
    contractSn: "",
    contractExpireTime: "",
    serviceFeeType: 2,
    serviceFee: undefined,
    userName: "",
    userTelephone: "",
    userEmail: "",
    address: "",
    bankCardId: "",
    bankAddress: "",
    bankAccount: "",
    accountType: 1,
    userID: "",
    accountPic: "",
    otherPic: "",
    pic1:'',
    pic2:'',
    licenseNumber:'',
}
export default {
    props: {
        id: {
            type: [Number, String],
            default: ""
        }
    },
    components: { ReceiptInfo, AccountInfo },
    data() {
        return {
            formData: {
                ...defaultFormData
            },
            dataLoading: false,
            btnLoading: false,
            userLoading: false,
            principalList: [],
            rules: {
                name: [{ required: true, message: "请填写名称" }],
                principalId: [{ required: true, message: "请选择代理商负责人" }],
                contractSn: [{ required: true, message: "请填写合同编号" }],
                contractExpireTime: [{ required: true, message: "请填写合同到期时间" }],
                userName: [{ required: true, message: "请填写收款联系人姓名" }],
                userTelephone: [{ required: true, message: "请填写收款联系人手机号" }],
                userEmail: [{ required: true, message: "请填写收款联系人邮箱" }],
                address: [{ required: true, message: "请填写通讯地址" }],
                bankCardId: [{ required: true, message: "请填写银行卡号" }],
                bankAddress: [{ required: true, message: "请填写开户网点" }],
                bankAccount: [{ required: true, message: "请填写银行账户名" }],
                userID: [{ required: true, message: "请填写营业执照编号" }],
                accountPic: [{ required: true, message: "请上传营业执照" }],
                otherPic: [{ required: true, message: "请上传开户许可证" }],
            },
            redirect: this.$route.query.redirect || '/finance/agent/manage/list',
        }
    },
    created() {
        if (this.id) {
            this.getDetailData();
        }
    },
    methods: {
        //获取详情
        getDetailData() {
            this.dataLoading = true;
            this.$request({
                url: "/agent/info",
                method: "POST",
                params: {
                    agentId: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        const _accountPic = result.accountPic ? result.accountPic.split(',') : [];
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            principalId: result.principal && result.principal.id || '',
                            pic1: _accountPic[0] || '',
                            pic2: _accountPic[1] || '', 
                            licenseNumber: result.userID
                        };
                        this.principalList = result.principal ? [{ ...result.principal, name: result.principal.name }] : [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        // 负责人搜索
        async searchPrincipal(query) {
            if (query !== "") {
                this.userLoading = true;
                const res = await this.$request({
                    url: '/adminUser/list',
                    method: 'POST',
                    params: { keyword: query }
                }).finally(() => {
                    this.userLoading = false;
                });

                const { state, result } = res.data;

                if (state == 1 && result) {
                    this.principalList = result;
                }
            }
        },
        //切换
        scopeChange(e) {
            this.$refs["formData"].clearValidate('serviceFee');
        },
         //设置图片
         setAccountPic(){
            const _pic = [];
            if(this.formData.pic1) _pic.push(this.formData.pic1);
            if(this.formData.pic2) _pic.push(this.formData.pic2);

            this.formData.accountPic = _pic.toString(); 
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.setAccountPic();
                    this.$request({
                        url: "/agent/edit",
                        method: "POST",
                        data: {
                            ...this.formData,
                            serviceFee: this.formData.serviceFeeType == 0 ? 0 : this.formData.serviceFee,
                            userID: this.formData.licenseNumber
                        },
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
    }
}
</script>

<style lang="scss" scoped></style>